import { createSelector } from '@ngrx/store';
import { ActionObjectType } from '@shared/models/sync/action-object-type';
import { selectVideoUploadsState } from '../../../video-uploads/video-uploads.selectors';
import { SyncProducer } from '../../models/sync-producer';
import { resolveSequenceDisplay } from './resolve-sequence-display';

// A synced sequence's business detail (title, date, preview, byte-weighted progress) lives on the
// video-uploads transport snapshot, so this producer exposes that slice to its resolver.
export const videoUploadsProducer: SyncProducer = {
  type: ActionObjectType.SEQUENCE,
  resolver: resolveSequenceDisplay,
  selectSlices: createSelector(selectVideoUploadsState, (videoUploads) => ({ videoUploads })),
};
